import React from "react";
import { useIntl } from "react-intl";
import { TextLink, Tooltip } from "@folio/stripes/components";
import { ROUTE_PATHS } from "../../types/routePaths";
export var PublisherLink = function (_a) {
    var name = _a.name, publisherId = _a.publisherId, tooltipId = _a.tooltipId;
    var formatMessage = useIntl().formatMessage;
    var renderUnpaired = function (_a) {
        var ref = _a.ref, ariaIds = _a.ariaIds;
        return (React.createElement("span", { ref: ref, "aria-labelledby": ariaIds.text, "data-testid": "publisher-unpaired" }, name));
    };
    if (!name) {
        return null;
    }
    if (!publisherId) {
        return (React.createElement(Tooltip, { id: tooltipId, text: formatMessage({
                id: "ui-br-legaldeposits.publisher.notInRegistry",
            }), placement: "top" }, renderUnpaired));
    }
    return (React.createElement(TextLink, { to: "".concat(ROUTE_PATHS.PUBLISHERS, "?detail=").concat(publisherId), "data-testid": "publisher-link", onClick: function (e) { return e.stopPropagation(); } }, name));
};
